import { Segmented, SegmentedProps } from 'antd'
import React, { Ref } from 'react'

import { SegmentedControlContainer } from './styles'

export interface SegmentedControlProps extends SegmentedProps {
  itemWidth?: string | number
  itemHeight?: string | number
  ref?: Ref<HTMLDivElement>
}

const SegmentedControl = (props: SegmentedControlProps) => {
  const segmentedProps = { ...props }
  delete segmentedProps.itemHeight
  delete segmentedProps.itemWidth
  return (
    <SegmentedControlContainer
      id="nova-shared-Segmented-Control-root"
      itemWidth={props.itemWidth}
      itemHeight={props.itemHeight}
    >
      <div className="segmented">
        <Segmented {...segmentedProps} />
      </div>
    </SegmentedControlContainer>
  )
}

export default SegmentedControl
